import { lazily } from '@mkmp/core'
import { BasicLayout } from '@/features/layout'

const { AcceptMgmt, AcceptDetail, AcceptEdit, AcceptConfirm } = lazily(() => import('@/features/accept'))

/**
 * 验收相关页面
 */
export default [
  {
    id: Symbol('accept'),
    path: 'accept',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <AcceptMgmt />,
        handle: {
          code: 'accept'
        }
      }
    ]
  },
  {
    id: Symbol('accept-detail'),
    path: 'accept/detail',
    element: <AcceptDetail />
  },
  {
    id: Symbol('accept-confirm'),
    path: 'accept/confirm',
    element: <AcceptConfirm />
  },
  {
    id: Symbol('accept-edit'),
    path: 'accept/edit',
    element: <AcceptEdit />
  }
]
